import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';

function Industries() {
  const industries = [
    {
      title: 'IT & Software',
      image: '/images/it_software.jpg',
      description: 'From startups to SaaS platforms, we deliver tailored financial compliance, IP registration, and R&D credit support.',
      bullets: ['Startup Structuring', 'ESOP & Cap Tables', 'Software Export Compliance', 'Intellectual Property Advisory'],
      link: '/industries/it-software',
    },
    {
      title: 'Manufacturing & Engineering',
      image: '/images/manufacturing.jpg',
      description: 'From raw material sourcing to export compliance and subsidy claims, we support manufacturing entities at scale.',
      bullets: ['Cost Structuring', 'Input Tax Credit Optimization', 'Factory Act & ESIC Support', 'Project Funding Assistance'],
      link: '/industries/manufacturing-engineering',
    },
    {
      title: 'Real Estate & Infrastructure',
      image: '/images/real_estate.jpg',
      description: 'Land, project structuring, and RERA – we advise real estate developers and contractors with end-to-end compliance.',
      bullets: ['RERA Registration & Audit', 'SPV Structuring', 'Construction Tax Planning', 'JV Compliance & Funding'],
      link: '/industries/real-estate',
    },
    {
      title: 'Media & Entertainment',
      image: '/images/media.jpg',
      description: 'We handle GST on services, royalty structuring, and talent contracts for production houses and influencers.',
      bullets: ['Contract Drafting Support', 'Withholding Tax Guidance', 'Cross-border Royalty Compliance', 'GST on Digital Services'],
      link: '/industries/media-entertainment',
    },
    {
      title: 'Retail & E-commerce',
      image: '/images/retail.jpg',
      description: 'Inventory, invoicing, taxation, and platform commission reconciliation for sellers and aggregators.',
      bullets: ['E-Invoicing Setup', 'Inventory Reconciliation', 'Marketplace TDS Management', 'GST Refunds & Returns'],
      link: '/industries/retail-ecommerce',
    },
    {
      title: 'Banking, Financial Services & Insurance (BFSI)',
      image: '/images/bsfi.jpg',
      description: 'From NBFC compliance to fintech reporting, we simplify financial regulations in BFSI.',
      bullets: ['RBI & SEBI Filings', 'GST on Financial Services', 'Tax on Mutual Funds & Insurance', 'FEMA Reporting'],
      link: '/industries/bfsi',
    },
    {
      title: 'Tourism & Hospitality',
      image: '/images/tourism.jpg',
      description: 'Hotel, travel agency, or OTA – our advisory spans GST classification, TCS, and international billing.',
      bullets: ['GST on Packages', 'Commission Taxation', 'Foreign Exchange Billing', 'Luxury Tax Advisory'],
      link: '/industries/tourism-hospitality',
    },
    {
      title: 'Aquaculture & Agriculture',
      image: '/images/agro_aqua.jpg',
      description: 'We help agribusinesses and aquaculture units manage subsidy paperwork, FSSAI, and input tax compliance.',
      bullets: ['FSSAI License Filing', 'Agri Subsidy Advisory', 'Customs Duty Management', 'Farmer Contract Structuring'],
      link: '/industries/agro-aqua',
    },
    {
      title: 'Health Care',
      image: '/images/healthcare.png',
      description: 'For hospitals, clinics, pharma, and diagnostic chains — audit, TDS, and CSR obligations.',
      bullets: ['Clinical Establishment Support', 'CSR & Trust Filings', 'Hospital Licensing Advisory', 'Doctor Payroll Structuring'],
      link: '/industries/healthcare',
    },
    {
      title: 'Education',
      image: '/images/education.jpg',
      description: 'Schools, colleges, and EdTech — we manage NPO registration, foreign funding compliance, and 80G filings.',
      bullets: ['Society/Trust Setup', 'Income Tax Exemption Filing', 'EdTech Licensing', 'Grant Management'],
      link: '/industries/education',
    },
    {
      title: 'NGOs and Trusts',
      image: '/images/ngos.png',
      description: 'We assist in FCRA registration, 12A/80G certification, and fund audit for NGOs.',
      bullets: ['FCRA Compliance', 'Donor Reporting', '12A & 80G Certification', 'Utilization Certificate Filing'],
      link: '/industries/ngos-trusts',
    },
  ];

  return (
    <div className="industries-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/industries-hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Industries We Serve</h1>
          <p>Empowering a diverse range of industries with financial, legal, and strategic excellence</p>
        </div>
      </section>

      {/* Industries List */}
      <div className="services-container">
        {industries.map((industry, index) => (
          <Link to={industry.link} key={index} className="industry-link">
            <div className={`service-section ${index % 2 !== 0 ? 'reverse' : ''}`}>
              <div className="service-image">
                <img src={industry.image} alt={industry.title} />
              </div>
              <div className="service-content">
                <h2>{industry.title}</h2>
                <p>{industry.description}</p>
                <ul>
                  {industry.bullets.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Industries;
